import { useEffect } from 'react';

// @aiContributed-MAPFuse-2026-06-15
export const AfterPageReady = () => {
  useEffect(() => {
    // do not remove: this dismisses the index.html fallback watchdog timer that would
    // otherwise reload the page with fallbackSource=true (mirrors the signup app core).
    (window as Window & { isPageReady?: boolean }).isPageReady = true;
  }, []);
  return null;
};
